import { t } from '@lingui/core/macro'
import React from 'react'
import { isDealer } from '@/core/enums/tipo-usuario'
import { Toggle, Tooltip } from '@tecsinapse/cortex-react'
import { IoMdInformationCircleOutline } from 'react-icons/io'
import { useFormContext } from 'react-hook-form'
import { FormMultiSelect } from '../../hook-form-connectors/form-multi-select'
import { OptionSelect } from '@/core/utils/types'
import { getLabel } from '@/core/utils/global-labels'

interface SelectDealersProps {
  render: boolean
  name: string
  options: OptionSelect[]
}

export const SelectDealers = ({
  render,
  name,
  options
}: SelectDealersProps) => {
  const { watch } = useFormContext()
  const { tipo: tipoGrupo, todosDealers } = watch()

  const { control, setValue } = useFormContext()

  if (!render) return null

  return (
    <div className={'w-full col-span-1 space-y-mili'}>
      {!isDealer(tipoGrupo?.id) ? (
        <div className={'flex flex-row gap-x-mili items-center'}>
          <Toggle
            name='todosDealers'
            checked={todosDealers}
            onChange={() => setValue('todosDealers', !todosDealers)}
          />
          <label
            htmlFor={'todosDealers'}
            className={'text-sub font-bold text-secondary-medium'}
          >
            {t`Incluir ${getLabel('label.dealers')} existentes`}
          </label>
          <Tooltip
            text={t`Esta opção irá ignorar ${getLabel('label.dealers')} no campo acima. Por sua vez, ela sempre irá considerar ${getLabel('label.dealers')} em atividade no momento que esse grupo de usuários for utilizado`}
            width={300}
            placement='right'
          >
            <IoMdInformationCircleOutline className='text-primary-medium' />
          </Tooltip>
        </div>
      ) : null}

      <FormMultiSelect
        name={name}
        options={options}
        disabled={todosDealers}
        label={getLabel('label.dealers')}
        withSearch
      />
    </div>
  )
}
